import { createWebHistory, createRouter } from "vue-router";

import ViewHome from "@/views/ViewHome.vue";
import ViewCustomers from "@/views/ViewCustomers.vue";
import ViewManageCustomer from "@/views/ViewManageCustomer.vue";
import ViewDistributors from "@/views/ViewDistributors.vue";
import ViewUsers from "@/views/ViewUsers.vue";
import ViewJobs from "@/views/ViewJobs.vue";
import ViewConfiguration from "@/views/ViewConfiguration.vue";

const routes = [
    {
        path: '/',
        name: 'Home',
        component: ViewHome,
    },
    {
        path: '/Customers',
        name: 'Customers',
        component: ViewCustomers,
        meta: { transition: 'page-fade' } 
        
    },
    {
        path: '/Customers/:customerReference',
        component: ViewManageCustomer,
        meta: { transition: 'page-fade' } 
    },
    {
        path: '/Users',
        name: 'Users',
        component: ViewUsers,
        meta: { transition: 'page-fade' } 
    },
    {
        path: '/Jobs',
        name: 'Jobs',
        component: ViewJobs,
        meta: { transition: 'page-fade' } 
    },
    {
        path: '/Configuration',
        name: 'Configuration',
        component: ViewConfiguration,
        meta: { transition: 'page-fade' } 
    },
];

// Pinia is not yet installed when this module runs, so useUserStore() can't be used here (same constraint as main.js downloadFile).
const user = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : null;

if (user != null && !user.hasDistributor) {
    routes.push({
        path: '/Distributors',
        name: 'Distributors',
        component: ViewDistributors,
    });
}

const router = createRouter({
    history: createWebHistory(),
    linkActiveClass: "active",
    routes,
});

export default router;